export default __webpack_public_path__ + "static/media/audio2.79f7302c.mp3";